import React, {useContext} from 'react';
import {themeGet} from '@styled-system/theme-get';
import Carousel from 'react-multi-carousel';
import styled from 'styled-components';
import {AuthContext} from "contexts/auth/auth.provider";

const responsive = {
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024,
        },
        items: 1,
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0,
        },
        items: 1,
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 200,
        },
        items: 1,
    },
};

const CarouselWithCustomDots = ({
                                    items = [],
                                    title,
                                    ...rest
                                }: any) => {
    const {deviceType: {mobile, tablet, desktop}} = useContext(AuthContext);

    const children = items
        .filter(m => m?.url)
        .slice(0, 6)
        .map((item: any, index: number) => {
            return <div key={index} className="bg-white flex justify-center">
                <img className="product-image object-contain h-56 sm:h48" src={item?.url}/>
            </div>
        });


    const images = items
        .filter(m => m?.url)
        .map((item: any, index: number) => (
            <img className="object-contain h-36 sm:h-48" src={item?.url}
                 style={{width: '100%', height: '100%', position: 'relative'}}/>
        ));


    const CustomDot = ({
                           index,
                           onClick,
                           active,
                           carouselState: {currentSlide, deviceType},
                       }: any) => {
        const SingleItem = styled.li`
                          border: 1px solid ${themeGet('colors.borderColor', '#f1f1f1')};
                          border-radius: 6px;
                          margin-right: 20px;
                          padding: 0;
                          outline: none;
                          width: ${mobile ? '40px' : '70px'};
                          height: auto;
                          overflow: hidden;
                    
                          &:last-child {
                            margin-right: 0;
                          }
                    
                          &.custom-dot--active {
                            border: 2px solid ${themeGet('colors.scuttleOrange', '#f15331')};
                          }
                        `;

        return (
            <SingleItem
                data-index={index}
                key={index}
                onClick={() => onClick()}
                className={`custom-dot ${active && 'custom-dot--active'}`}
            >
                {React.Children.toArray(images)[index]}
            </SingleItem>
        );
    };

    let deviceType = 'desktop';
    if (mobile) {
        deviceType = 'mobile';
    }
    if (tablet) {
        deviceType = 'tablet';
    }


    return (
        <Carousel
            showDots={images.length > 1}
            ssr
            infinite={true}
            slidesToSlide={1}
            containerClass={images.length > 1 ? 'pb-12 sm:pb-24' : ''}
            responsive={responsive}
            deviceType={deviceType}
            autoPlay={false}
            arrows={false}
            customDot={<CustomDot/>}
            {...rest}
        >
            {children}
        </Carousel>
    );
};

export default CarouselWithCustomDots;
